module.exports = __webpack_public_path__ + "598e0141d791ea10172a766cca9c1ea4.svg";